// Simplified version without path storage
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SessionManager } from '../components/ComponentsLibrary';

  const defaultPermissionsForFields = {
    btnNext: { read: false, write: false, hide: false },
    btnNew: { read: false, write: false, hide: false },
    btnQueue: { read: false, write: false, hide: false },
    btnCompleted: { read: false, write: false, hide: false },
    btnNewWorkflow: { read: false, write: false, hide: false },
    btnViewDocument: { read: false, write: false, hide: false }, 
    btnNewDocument: { read: false, write: false, hide: false },
    btnReporting: { read: false, write: false, hide: false },
    btnAdmin: { read: false, write: false, hide: false },
    btnLegal: { read: false, write: false, hide: false },

  };

const PermissionProtectedRoute = ({ children, requiredPermission }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 🔍 FIXED: Function to check permissions (handles both single and array)
  const checkPermissions = (userPermissions) => {
    // Handle array of permissions (OR logic - user needs at least one)
    if (Array.isArray(requiredPermission)) {
      const hasAnyPermission = requiredPermission.some(permission => {
        const hasPermission = !(userPermissions[permission]?.hide ?? false);
        console.log(`🔍 Checking permission ${permission}:`, hasPermission);
        return hasPermission;
      });
      
      console.log(`🔍 User has at least one required permission [${requiredPermission.join(', ')}]:`, hasAnyPermission);
      return hasAnyPermission;
    }
    
    // Handle single permission (string)
    const hasPermission = !(userPermissions[requiredPermission]?.hide ?? false);
    console.log(`🔍 Checking single permission ${requiredPermission}:`, hasPermission);
    return hasPermission;
  };
  
  useEffect(() => {
    // Get user permissions
    const userPermissions = SessionManager.GetDataFromSession("UserPermissions") || defaultPermissionsForFields;
    const hasPermission = !(userPermissions[requiredPermission]?.hide ?? false);
    
    if (!hasPermission) {
      console.log(`🔍 Access denied to ${location.pathname} - missing permission: ${requiredPermission}`);
      
      // Simply go back or to default page
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/error", { replace: true });
      }
    }
  }, [requiredPermission, navigate, location.pathname]);
  
  // Check permission
  const userPermissions = SessionManager.GetDataFromSession("UserPermissions") || defaultPermissionsForFields;
  const hasPermission = !(userPermissions[requiredPermission]?.hide ?? false);
  
  if (!hasPermission) {
    return null;
  }
  
  return children;
};

export default PermissionProtectedRoute;

